import { isWeixin, isAndroid ,isWxMiniProgram} from "../utils";
import qs from "qs";
import { getOpenid, getUserInfo, authorizationCheck } from "../api";
import wx from "weixin-js-sdk";

export default {
  data() {
    return {
      phone: null,
      isEc: false,
      isCouponRecord: false,
      u_t: '',
      // 小程序id
      currentAppId: 'wxe766d738ad655e8c',
      // 小程序原始id
      originalAppId: 'gh_e0f5951e0d87'
    };
  },
  created () {
  },
  mounted () {
    var linkTerminal = this.$route.query.a;
    this.isCouponRecord = this.$route.query?.requiredUserInfo;
    this.u_t = this.$route.query?.u_t;
    const preCode = sessionStorage.getItem('code')
    if (isWeixin() || linkTerminal == 1 || linkTerminal == '1') {
      const search = qs.parse(window.location.search, {
        ignoreQueryPrefix: true,
      });
      const code = search.code;
      this.phone = this.$route.query.mmm;
      if (this.phone?.includes("OL")) {
        // this.isEc = true
        this.phone = this.phone.replace('OL', '')
        this.currentAppId = 'wxe766d738ad655e8c'
        this.originalAppId = 'gh_e0f5951e0d87'
      }

      if (this.isEc) {
        // 电商小程序打开，不走微信授权流程
        this.hanglePageInit();
      } else if(isWeixin()){
        //因为开发和测试环境没配置微信授权url。所以不在开发和预生产环境运行微信授权
        if (process.env.VUE_APP_ENV === 'prod' || process.env.VUE_APP_ENV === 'pre'){
          this.getCode(code)
        }else{
          this.hanglePageInit();
        }
      }else{
        this.hanglePageInit();
      }

    } else {
      this.hanglePageInit();
    }
  },
  methods: {
    getCode (code) {
      if (code) {
        // var state = {
        //   title: 'title',
        //   url: window.location.href
        // }
        // history.pushState(state, null, window.location.href)
        // window.addEventListener('popstate', (event) => {
        //   console.log('监听回退')
        //   wx.miniProgram.getEnv((res) => {
        //     if (res.miniprogram) {
        //       wx.miniProgram.navigateBack()
        //     } else {
        //       console.log('不在小程序里')
        //     }
        //   })
        // }, false);
        if (this.isCouponRecord || this.isCouponRecord =='true') {
          getUserInfo({ code }).then((res) => {
          })
        }
        getOpenid({ code }).then((res) => {
          if (res.code === 200) {
            if (res.busCode === "1") {
              if (res.data) {
                const openid = res.data;
                sessionStorage.setItem('code', code)
                sessionStorage.setItem("openid", openid);
                this.hanglePageInit(openid);
              } else {
                const preCode = sessionStorage.getItem('code')
                const preOpenid = sessionStorage.getItem("openid");
                if (preCode === code) {
                  this.hanglePageInit(preOpenid);
                } else {
                  this.hanglePageInit();
                }
              }
            } else {
              this.$toast({ message: res.busMessage });
            }
          } else {
            this.$toast({ message: res.message });
          }
        }).catch((res) => {
          console.log("获取失败");
        });
      } else if (process.env.VUE_APP_ENV === 'prod' || process.env.VUE_APP_ENV === 'pre'){//因为开发和测试环境没配置微信授权url。所以不在这个环境运行微信授权
        if ((this.isCouponRecord || this.isCouponRecord == 'true') && this.u_t) {
          // 是否需要授权
          authorizationCheck().then((res) => {
            if (res.code === 200) {
              if (res.busCode === "1") {
                if (res.data) {
                  const redirect_uri = encodeURIComponent(window.location.href);
                  const appId = this.$config.env.VUE_APP_APPID;
                  const url = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appId}&redirect_uri=${redirect_uri}&response_type=code&scope=snsapi_userinfo&state=STATE&connect_redirect=1#wechat_redirect`;
                  window.location.href = url;
                }
                else {
                  this.hanglePageInit()
                  // const redirect_uri = encodeURIComponent(window.location.href);
                  // const appId = this.$config.env.VUE_APP_APPID;
                  // const url = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appId}&redirect_uri=${redirect_uri}&response_type=code&scope=snsapi_base&state=STATE&connect_redirect=1#wechat_redirect`;
                  // window.location.href = url;
                }
              } 
            }
          })
        } else {
          this.hanglePageInit()
          // const redirect_uri = encodeURIComponent(window.location.href);
          // const appId = this.$config.env.VUE_APP_APPID;
          // const url = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appId}&redirect_uri=${redirect_uri}&response_type=code&scope=snsapi_base&state=STATE&connect_redirect=1#wechat_redirect`;
          // window.location.href = url;
        }
      }
    }

  }
};
